module.exports = {
  messages: {
    ADVERTISING_DIGITAL_SERVICE_ACT_HEADLINE: 'Pourquoi cette publicité ?',
    ADVERTISING_DIGITAL_SERVICE_ACT_POP_UP_FOOTER_CTA: 'En savoir plus',
    ADVERTISING_DIGITAL_SERVICE_ACT_POP_UP_FOOTER_MESSAGE:
      'sur les critères de ciblage possibles.',
    ADVERTISING_DIGITAL_SERVICE_ACT_POP_UP_MESSAGE:
      "Vous visualisez cette publicité parce que vous correspondez à un ou plusieurs des critères de ciblage de l'annonceur.",
    ADVERTISING_LEAD_AD_FORM_CHECKBOX_ERROR:
      'Veuillez cocher la case pour continuer',
    CARDS_SECTION_DESCRIPTION: 'Critères de recherche souvent utilisés :',
    CARDS_SECTION_REGISTRATION_BUTTON_TEXT: "Je m'inscris",
    CARDS_SECTION_REGISTRATION_TEXT:
      'Créez un profil XING et accédez à tous les outils de recherche.',
    CARDS_SECTION_TITLE:
      "Une manière intelligente de dénicher des offres d'emploi.",
    CAREER_HUB_TEASER_CARD_DESCRIPTION:
      "Découvrez les meilleurs articles, des conseils d'experts confirmés et de spécialistes.",
    CAREER_HUB_TEASER_CARD_TITLE: 'Découvrez le guide professionnel XING',
    COMPANIES_SECTION_SUBTITLE:
      'Découvrez des entreprises qui vous correspondent.',
    COMPANIES_SECTION_TITLE: 'Employeurs populaires sur XING',
    CP_HIRING: 'Postes à pourvoir',
    'CP_TOP_COMPANIES_CARD_BUTTON.one': 'Voir {value} offre',
    'CP_TOP_COMPANIES_CARD_BUTTON.other': 'Voir {value} offres',
    CP_TOP_COMPANIES_CARD_HIGHLIGHT:
      '{percentage} % des utilisateurs ont recommandé cet employeur sur kununu. ',
    CRATE_LOSP_CAREER_HUB_CARD_DESCRIPTION:
      "Découvrez les meilleurs conseils et articles de professionnels et d'experts.",
    CRATE_LOSP_CAREER_HUB_CARD_TITLE: 'Le guide professionnel XING',
    CRATE_LOSP_COMPANIES_SECTION_SUBTITLE:
      'Découvrez des entreprises qui recrutent.',
    CRATE_LOSP_COMPANIES_SECTION_TITLE:
      'Plus de 270 000 employeurs sont à la recherche de profils comme le vôtre',
    CRATE_LOSP_CV_CARD_DESCRIPTION:
      'Faites une excellente première impression et décrochez les entretiens que vous souhaitez.',
    CRATE_LOSP_CV_CARD_TITLE: 'Le CV parfait au format PDF',
    CRATE_LOSP_PROFILE_CARD_DESCRIPTION:
      "Créez un profil, définissez vos préférences professionnelles et recevez automatiquement des offres d'emploi !",
    CRATE_LOSP_PROFILE_CARD_TITLE: 'Soyez trouvé(e) facilement !',
    CRATE_LOSP_RECRUITERS_SECTION_SUBTITLE:
      "Nouez directement le contact avec les responsables RH d'employeurs renommés.",
    CRATE_LOSP_RECRUITERS_SECTION_TITLE:
      'Plus de 20 000 recruteurs vous attendent',
    CRATE_LOSP_REGISTER_BUTTON: 'Créer un profil',
    CRATE_LOSP_REGISTER_WITH_GOOGLE_BUTTON: 'Continuer avec Google',
    DESCRIPTION_CARD_1: 'Travaillez où vous le souhaitez.',
    DESCRIPTION_CARD_2: 'Travaillez quand vous le souhaitez.',
    DESCRIPTION_CARD_3: 'Découvrez toutes vos possibilités.',
    DESCRIPTION_CARD_4: 'Soyez rémunéré(e) à votre juste valeur.',
    DESCRIPTION_CARD_5:
      'Postes qui vous laissent suffisamment de temps à consacrer à autre chose.',
    DESCRIPTION_CARD_6: 'Si vous souhaitez vous lancer en douceur.',
    'DISCO_OBJECTS_FOLLOWER.one': 'abonné',
    'DISCO_OBJECTS_FOLLOWER.other': 'abonnés',
    'DISCO_OBJECTS_FOLLOWER.zero': 'abonnés',
    ERROR_REGISTER_EMAIL_MAX_CHANGE:
      "Vous pouvez effectuer jusqu'à 10 changements d'adresse e-mail.",
    JOBS_FIND_JOBS_RECRUITERS_LINK:
      "Vous souhaitez publier des offres d'emploi ? <a>Cliquez ici.</a>",
    JOBS_FIND_JOBS_RECRUITERS_LINK_FIRST_LINE: 'Publier une offre ?',
    JOBS_FIND_JOBS_RECRUITERS_LINK_SECOND_LINE: 'Cliquez ici.',
    JOBS_FIND_JOBS_SEARCH_BUTTON: 'Trouver des offres',
    JOBS_FIND_JOBS_SEARCH_LOCATION_PLACEHOLDER: 'Lieu',
    JOBS_FIND_JOBS_SEARCH_PLACEHOLDER:
      "Entrer l'intitulé du poste ou un mot-clé",
    JOBS_FIND_JOBS_SEARCH_RADIUS_PLACEHOLDER: 'Rayon',
    JOBS_FIND_JOBS_TITLE: 'Trouver des offres',
    JOBS_JOB_TEASER_SAVE: 'Sélectionner cette offre',
    JOBS_JOB_TEASER_SAVED: 'Sélectionnée',
    JOBS_LANDING_LO_MARKETING_SEC_ONE_TEXT_ONE:
      "Plus d'1 million d'offres d'emploi",
    JOBS_LANDING_LO_MARKETING_SEC_ONE_TEXT_THREE:
      "Webinaire sur la recherche d'emploi",
    JOBS_LANDING_LO_MARKETING_SEC_ONE_TEXT_TWO:
      'Plus de 20 millions de membres',
    JOBS_RECENT_SEARCH_EMPTY: 'Toutes les offres',
    JOBS_SEARCH_AI_HEADLINE: 'Une nouvelle manière de chercher un emploi',
    JOBS_SEARCH_AI_INPUT_PLACEHOLDER_1: 'Décrivez le job de vos rêves...',
    JOBS_SEARCH_AI_INPUT_PLACEHOLDER_10:
      'Mentionnez aussi vos expériences et compétences...',
    JOBS_SEARCH_AI_INPUT_PLACEHOLDER_2:
      'Écrivez simplement en langage naturel...',
    JOBS_SEARCH_AI_INPUT_PLACEHOLDER_3: 'Emplois que vous aimeriez exercer...',
    JOBS_SEARCH_AI_INPUT_PLACEHOLDER_4:
      'Vos idées pour votre prochaine évolution de carrière...',
    JOBS_SEARCH_AI_INPUT_PLACEHOLDER_5:
      'Intitulé du poste, niveau de carrière, salaire souhaité ...',
    JOBS_SEARCH_AI_INPUT_PLACEHOLDER_6:
      'Tout ce qui est important à vos yeux sur le plan professionnel ...',
    JOBS_SEARCH_AI_INPUT_PLACEHOLDER_7:
      "Plus vous êtes précis(e), mieux c'est...",
    JOBS_SEARCH_AI_INPUT_PLACEHOLDER_8:
      'Temps partiel ou temps complet, télétravail, présentiel ou hybride',
    JOBS_SEARCH_AI_INPUT_PLACEHOLDER_9:
      "Évitez de n'utiliser que des mots-clés",
    JOBS_SEARCH_AI_SALARY_SUGGESTION: 'I want to earn more',
    JOBS_SEARCH_AI_SALARY_SUGGESTION_SUBTITLE: 'Find better-paying jobs',
    JOBS_SEARCH_AI_SWIMP_SUGGESTION: 'Rechercher avec mon profil',
    JOBS_SEARCH_AI_SWIMP_SUGGESTION_SUBTITLE: 'Trouvez votre prochain emploi',
    JOBS_SEARCH_AI_SWIMS_SUGGESTION: 'Aide à la reconversion professionnelle',
    JOBS_SEARCH_AI_SWIMS_SUGGESTION_SUBTITLE:
      'Découvrez de Découvrez de toutes nouvelles opportunités de carrière avec XING.',
    JOBS_SEARCH_LOCATION_NO_RADIUS: 'Sans rayon',
    LEAD_AD_FORM_ACCESSIBILITY_LABEL: 'Formulaire de contact',
    LEBENSLAUF_TEASER_CARD_DESCRIPTION:
      "Boostez en un rien de temps vos chances de décrocher un entretien d'embauche.",
    LEBENSLAUF_TEASER_CARD_TITLE:
      'Le CV parfait au format PDF en quelques clics',
    LOADING_ERROR_BODY: 'Veuillez réessayer ultérieurement.',
    LOADING_ERROR_CTA: 'Réessayer',
    LOADING_ERROR_HEADLINE: 'Désolé, une erreur est survenue.',
    LOGGED_OUT_STARTPAGE_META_DESCRIPTION_JOB_SEARCH:
      " Plus d'un million d'offres d'emploi ✓ 20 000 recruteurs ✓ Fourchettes de salaires ✓ Évaluations des employeurs. Définissez vos attentes professionnelles et faites votre XING !",
    LOGGED_OUT_STARTPAGE_META_TITLE_JOB_SEARCH:
      "Trouvez l'emploi qui vous correspond. Ou soyez trouvé(e) !. ",
    LOSP_APPLE_BUTTON: "Télécharger sur l'App Store",
    LOSP_GOOGLE_BUTTON: 'Télécharger sur Google Play',
    LOSP_JOBS_SECTION_SUBTITLE:
      "Il s'agit des offres d'emploi les plus consultées au cours de la dernière semaine.",
    LOSP_JOBS_SECTION_TITLE: 'Offres les plus vues sur XING',
    LOSP_KEYWORDS_ACCOUNTANT: '🧮 Accountant',
    LOSP_KEYWORDS_ADMINISTRATION: '🏫 Administration',
    LOSP_KEYWORDS_ANALYST: '📈 Data analyst',
    LOSP_KEYWORDS_BANKER: '💸 Banker',
    LOSP_KEYWORDS_CALLCENTER: '📞 Call centre jobs',
    LOSP_KEYWORDS_CAREERCHANGER: '👣 Career changer',
    LOSP_KEYWORDS_CARETAKER: '👨‍🔧 Facility manager',
    LOSP_KEYWORDS_CONTROLLER: '🎚️ Controller',
    LOSP_KEYWORDS_DESIGN: '🎨 Design jobs',
    LOSP_KEYWORDS_FLIGHTATTENDANT: '🛫 Flight attendant',
    LOSP_KEYWORDS_FORKLIFT: '👷 Forklift driver',
    LOSP_KEYWORDS_FOUNDATION: ' 🏛️ fondation',
    LOSP_KEYWORDS_FREELANCE: '👨🏻‍💻 Freelance jobs',
    LOSP_KEYWORDS_HEALTH: '🥕 Health manager',
    LOSP_KEYWORDS_LOGISTICS: '📦 Logistics jobs',
    LOSP_KEYWORDS_MARKETING: '📣 Marketing jobs',
    LOSP_KEYWORDS_MUSEUM: '🖼️ Museum jobs',
    LOSP_KEYWORDS_NURSERY: '👶 Nursery teacher',
    LOSP_KEYWORDS_OFFICECLERK: '👩‍💻 Office clerk',
    LOSP_KEYWORDS_PROJECTMANAGER: '🤹 Project manager',
    LOSP_KEYWORDS_PSYCHOLOGIST: '🛋️ Psychologist',
    LOSP_KEYWORDS_SALES: '💼 Field sales representative',
    LOSP_KEYWORDS_SALES2: '💰 Sales jobs',
    LOSP_KEYWORDS_SECURITY: '👮🏻 Security officer',
    LOSP_KEYWORDS_SOCIALMEDIA: '🤳 Social media manager',
    LOSP_KEYWORDS_SOCIALWORKER: '👨‍👧‍👦 Social worker',
    LOSP_KEYWORDS_SOCIALWORKER2: '❤️‍🔥assistant(e) social(e)',
    LOSP_KEYWORDS_SUSTAINABILITY: '🌿 Sustainability jobs',
    LOSP_KEYWORDS_TRUCK: '🚚 Lorry driver',
    LOSP_KEYWORDS_WORKINGSTUDENT: '🧑🏽‍🎓 Working student',
    LOSP_PREFERENCES_EXPERIMENT_CITIES_BERLIN: 'Berlin',
    LOSP_PREFERENCES_EXPERIMENT_CITIES_BUTTON: 'Villes',
    LOSP_PREFERENCES_EXPERIMENT_CITIES_HAMBURG: 'Hambourg',
    LOSP_PREFERENCES_EXPERIMENT_CITIES_HEADLINE:
      'Dans quelle ville souhaitez-vous travailler ?',
    LOSP_PREFERENCES_EXPERIMENT_CITIES_MUNICH: 'Munich',
    LOSP_PREFERENCES_EXPERIMENT_EMPTY_POPUP_BODY:
      "Sélectionnez au moins une préférence professionnelle : ceci nous permettra de vous proposer des offres d'emploi correspondant à vos attentes.",
    LOSP_PREFERENCES_EXPERIMENT_EMPTY_POPUP_BUTTON: "J'ai compris",
    LOSP_PREFERENCES_EXPERIMENT_EMPTY_POPUP_HEADLINE:
      'Veuillez sélectionner au moins une préférence.',
    LOSP_PREFERENCES_EXPERIMENT_HEADLINE: 'Soyez trouvé(e) par les recruteurs',
    LOSP_PREFERENCES_EXPERIMENT_LEVEL_BUTTON: 'Niveau de carrière',
    LOSP_PREFERENCES_EXPERIMENT_LEVEL_ENTRY: 'Débutant(e)',
    LOSP_PREFERENCES_EXPERIMENT_LEVEL_HEADLINE:
      'Quel niveau de carrière pour votre prochain emploi ?',
    LOSP_PREFERENCES_EXPERIMENT_LEVEL_MANAGER: 'Manager',
    LOSP_PREFERENCES_EXPERIMENT_LEVEL_PROFESSIONAL: 'Expérimenté(e)',
    LOSP_PREFERENCES_EXPERIMENT_OTHERS_DISCIPLINES: "Domaines d'activité",
    LOSP_PREFERENCES_EXPERIMENT_OTHERS_HEADLINE:
      'Quels sont vos autres préférences professionnelles ?',
    LOSP_PREFERENCES_EXPERIMENT_OTHERS_INDUSTRIES: "Secteurs d'activité",
    LOSP_PREFERENCES_EXPERIMENT_OTHERS_JOBTITLE: 'Intitulés de postes',
    LOSP_PREFERENCES_EXPERIMENT_OTHERS_WORKING_HOURS: 'Horaires de travail',
    LOSP_PREFERENCES_EXPERIMENT_PLACE_BUTTON: 'Votre lieu de travail',
    LOSP_PREFERENCES_EXPERIMENT_PLACE_HEADLINE:
      "Comment souhaitez-vous travailler à l'avenir ?",
    LOSP_PREFERENCES_EXPERIMENT_PLACE_HOMEOFFICE: '100% télétravail',
    LOSP_PREFERENCES_EXPERIMENT_PLACE_ONSITE: 'Au bureau',
    LOSP_PREFERENCES_EXPERIMENT_SALARY_BUTTON: 'Salaire',
    LOSP_PREFERENCES_EXPERIMENT_SALARY_EIGHTY: '80 000 €',
    LOSP_PREFERENCES_EXPERIMENT_SALARY_FORTY: '40 000 €',
    LOSP_PREFERENCES_EXPERIMENT_SALARY_FORTY_FIVE: '45 000 €',
    LOSP_PREFERENCES_EXPERIMENT_SALARY_HEADLINE:
      'Quel est votre salaire annuel souhaité ?',
    LOSP_PREFERENCES_EXPERIMENT_SALARY_SIXTY: '60 000€',
    LOSP_PREFERENCES_EXPERIMENT_SALARY_THIRTY: '30 000 €',
    LOSP_PREFERENCES_EXPERIMENT_SAVE:
      'Enregistrer mes attentes professionnelles',
    LOSP_PREFERENCES_EXPERIMENT_SAVE_POPUP_BODY:
      "De nombreux employeurs de renom et plus de 20.000 recruteurs recherchent des profils comme le vôtre sur XING. Soyez trouvé(e) et découvrez des recommandations d'offres d'emploi qui vous correspondent vraiment : avec votre propre profil XING.",
    LOSP_PREFERENCES_EXPERIMENT_SAVE_POPUP_BUTTON: "Je m'inscris",
    LOSP_PREFERENCES_EXPERIMENT_SAVE_POPUP_HEADLINE:
      "Les offres d'emploi viennent à vous",
    LOSP_PREFERENCES_EXPERIMENT_SEE_MORE: 'Voir plus',
    LOSP_PREFERENCES_EXPERIMENT_SUBHEADLINE:
      '... au lieu de cherchez vous-même. Dites-nous ce qui est important à vos yeux.',
    LOSP_PREFERENCES_EXPERIMENT_WORKPLACE_HOME_OFFICE: '100% télétravail',
    LOSP_PREFERENCES_EXPERIMENT_WORKPLACE_MOSTLY_HOME:
      'Principalement en télétravail',
    LOSP_PREFERENCES_EXPERIMENT_WORKPLACE_OFFICE: 'En présentiel',
    LOSP_PREFERENCES_EXPERIMENT_WORKPLACE_PARTLY_HOME: 'Télétravail partiel',
    LOSP_QR_CODE: "Code QR pour télécharger l'application",
    LOSP_RECRUITERS_SECTION_COMPANY_CTA: 'Voir les offres',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_AIRBUS:
      '80% de recommandation au cours des deux dernières années',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_AMAZON:
      'Avantages pour les employés : rabais, parking, événements corporate',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_AOK:
      'Plus de 1 440 évaluations "Très bien"',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_AUDI:
      '86% des employés sont satisfaits de leur salaire',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_BAHNE_GROTH:
      'Recruteur pour le siège de flaschenpost',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_BASF:
      "Avantages fréquemment confirmés : horaires de travail flexibles, télétravail, retraite d'entreprise",
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_BMW:
      "Avantages fréquemment confirmés - restaurant d'entreprise, prévoyance retraite, réductions",
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_BOSCH:
      "Avantages fréquemment confirmés : horaires de travail flexibles, médecin d'entreprise",
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_CAROLA_LUDEWIG:
      'Recrutement de professionnels de la sécurité de différents niveaux',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_DEUTSCHE_BAHN:
      '74% de recommandation au cours des deux dernières années',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_DEUTSCHE_BANK:
      "Avantages fréquemment confirmés : horaires de travail flexibles, télétravail, retraite d'entreprise",
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_DEUTSCHE_POST:
      "Plus de 12 250 avis d'employés et candidats",
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_DM:
      '70% de recommandation au cours des deux dernières années',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_DUERENHOFF_GMBH:
      'Top 10 kununu : employeurs les plus "family friendly" en Allemagne',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_FATMA_KOC:
      'Sourcing actif dans le secteurs Financial Services',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_FINJA_STRUBER:
      "Recruteuse pour le siège de l'entreprise ROSSMANN",
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_HUSEYIN_YALCIN:
      'Taux de réponse : moins de 3 heures',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_IKEA:
      "Avantages fréquemment confirmés : réductions, restaurant d'entreprise, prévoyance retraite, ",
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_ISABEL_STRUSCHKA:
      'Interlocutrice pour les domaines finances, IT, people et culture',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_JAN_GOTZE:
      'Recrutement de spécialistes et cadres dans le secteur informatique et IT',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_JAN_SCHENGBER:
      'Taux de réponse : moins de 4 heures',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_JOHANNA_ECKERT:
      'Recruteuse dans le domaine Fiscalité & audit/contrôle de gestion',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_JONAS_MASANNECK:
      'Recruteur dans le secteur Non-Tech & Life Sciences',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_JULIA_REICHHOFER:
      'Recruteuse pour tous les postes au sein du Schmersal Group.',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_KAUFLAND:
      "Plus de 2967 avis d'employés et candidats",
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_KRISTIN_SEMELKA:
      'Recruteuse, notamment dans le domaine de l’apprentissage',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_LIDL: 'kununu Top Company 2023',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_MALTE_BALMER:
      "Votre interlocuteur privilégié pour toute question relative aux offres d'emploi chez OTTO",
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_MARIA_HEUCKE:
      'La passion du recrutement #WeEmpowerPeople',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_MEINESTADT_DE:
      '88% de recommandation au cours des deux dernières années',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_MIRIAM_DJAMBOU:
      'Recrutement dans le domaine IT & Engineering',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_OTTOBOCK:
      "Avantages fréquemment confirmés : horaires de travail flexibles, médecin d'entreprise",
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_PORSCHE:
      '95% des employés sont satisfaits de leur salaire',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_RALPH_OSTERMEIER:
      "Votre interlocuteur pour les offres d'emploi IT chez EDEKA",
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_REWE:
      '61% de recommandation au cours des deux dernières années',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_ROBIN_MAURER:
      'Recrutement & Employer Branding pour trois entreprises',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_ROSSMANN:
      "Plus de 1621 avis d'employés et candidats",
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_SAP:
      '93% de recommandations au cours des deux dernières années',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_SARAH_BAUDZUS:
      "Plus de 10 ans d'expérience dans le domaine de la santé et des soins hospitaliers",
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_SIEMENS:
      '67% confirment les horaires de travail flexibles',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_STEFANIE_KLOCK:
      'Recrutement de spécialistes de la vente et du marketing',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_VANESSA_STRAUCH:
      'Recruteuse dans le secteur transport et logistique',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_VERONIKA_GERSDORF:
      'Recruteuse pour des postes de cols bleus et cols blancs',
    LOSP_RECRUITERS_SECTION_RECRUITER_CTA: 'Voir le profil',
    LOSP_SEARCH_INSPIRATION_CAREER_LEVEL: 'Votre niveau de carrière',
    LOSP_SEARCH_INSPIRATION_DESCRIPTION_CARD_1:
      'Travaillez où vous le souhaitez.',
    LOSP_SEARCH_INSPIRATION_DESCRIPTION_CARD_5:
      "Pour qu'il vous reste du temps à consacrer à autre chose.",
    LOSP_SEARCH_INSPIRATION_DESCRIPTION_CARD_6:
      'Si vous souhaitez vous lancer en douceur.',
    LOSP_SEARCH_INSPIRATION_PREFERENCES_CAREER_LEVEL_HEADLINE:
      'Quel est le niveau de carrière visé ?',
    LOSP_SEARCH_INSPIRATION_PREFERENCES_DESCRIPTION:
      'Sélectionnez les éléments importants à vos yeux pour obtenir des recommandations plus pertinentes.',
    LOSP_SEARCH_INSPIRATION_PREFERENCES_DESCRIPTION_2:
      "C'est simple et rapide !\n",
    LOSP_SEARCH_INSPIRATION_PREFERENCES_MODAL_SUBHEADLINE:
      "Sélectionnez les éléments importants à vos yeux pour obtenir des offres d'emploi plus pertinentes. C'est simple et rapide !",
    LOSP_SEARCH_INSPIRATION_PREFERENCES_MODAL_TITLE:
      'Vos attentes professionnelles',
    LOSP_SEARCH_INSPIRATION_PREFERENCES_SALARY_HEADLINE:
      'Quelles sont vos prétentions salariales ?',
    LOSP_SEARCH_INSPIRATION_PREFERENCES_TITLE: 'Vos attentes professionnelles',
    LOSP_SEARCH_INSPIRATION_PREFERENCES_WORKPLACE_HEADLINE:
      'Ou souhaitez-vous travailler ?',
    LOSP_SEARCH_INSPIRATION_SALARY: 'Salaire souhaité',
    LOSP_SEARCH_INSPIRATION_SET_PREFERENCES:
      'Enregistrer mes attentes professionnelles',
    LOSP_SEARCH_INSPIRATION_TITLE_CARD_1: 'Postes en télétravail',
    LOSP_SEARCH_INSPIRATION_TITLE_CARD_3:
      "Offres d'emploi dans différents domaines",
    LOSP_SEARCH_INSPIRATION_WORKPLACE: 'Votre lieu de travail',
    LOSP_SEO_SECTION_COMPANIES_DIRECTORY: 'Entreprises de A à Z',
    LOSP_SEO_SECTION_HEADER_DIRECTORIES: 'Répertoires',
    LOSP_SEO_SECTION_HEADER_JOB_ROLES: 'Postes',
    LOSP_SEO_SECTION_HEADER_TOP_LOCATIONS: 'Top villes',
    LOSP_SEO_SECTION_HEADER_TOP_SKILLS: 'Compétences-clés',
    LOSP_SEO_SECTION_JOBS_DIRECTORY: "Offres d'emploi de A à Z",
    LOSP_SEO_SECTION_PEOPLE_DIRECTORY: 'Membres de A à Z',
    MORE_OPTIONS_ACCESSIBILITY_LABEL: "Plus d'options",
    NATIVE_ADS_DOT_MENU_REPORT_OBJECT: 'Signaler cette annonce',
    NATIVE_ADS_LEARN_MORE_BUTTON: 'En savoir plus',
    NATIVE_ADS_SPONSORED_LABEL: 'Sponsorisé',
    NETWORK_DIRECT_CONNECTIONS_HIRING_HIGHLIGHTS_CTA: 'Afficher les détails',
    NETWORK_MY_NETWORK_BOOST_ME_UP_BANNER_CTA: 'Jetzt Profil boosten',
    NETWORK_MY_NETWORK_BOOST_ME_UP_BANNER_HEADLINE_1: 'Schneller zum',
    NETWORK_MY_NETWORK_BOOST_ME_UP_BANNER_HEADLINE_2: 'nächsten Job',
    NETWORK_MY_NETWORK_BOOST_ME_UP_BANNER_PRE_HEADLINE: 'Kostenlos für Dich',
    NETWORK_MY_NETWORK_BOOST_ME_UP_BANNER_SUBLINE:
      'Heb Dein Profil 14 Tage lang für Recruiter·innen hervor und sicher Dir die Chance auf mehr Job-Angebote.',
    NETWORK_MY_NETWORK_PROFILE_COMPLETION_CARD_CTA_100: 'Actualiser le profil',
    NETWORK_MY_NETWORK_PROFILE_COMPLETION_CARD_DESCRIPTION_100:
      "Vérifiez régulièrement votre profil pour vous assurer qu'il est à jour.",
    NETWORK_MY_NETWORK_ROMP_BASIC_BANNER_GET_PROJOBS_CTA: 'Opter pour ProJobs',
    NETWORK_MY_NETWORK_ROMP_BASIC_NO_VISITORS_BANNER_BODY:
      'Avec ProJobs, boostez votre visibilité et soyez trouvé(e) plus facilement. ',
    NETWORK_MY_NETWORK_ROMP_BASIC_NO_VISITORS_BANNER_HEADLINE:
      "Quels professionnels des RH s'intéressent à vous ?",
    NETWORK_MY_NETWORK_ROMP_BASIC_WITH_VISITORS_BANNER_BODY:
      "Ces professionnels des RH ont consulté votre profil. Avec ProJobs, découvrez de qui il s'agit.",
    NETWORK_MY_NETWORK_ROMP_BASIC_WITH_VISITORS_BANNER_HEADLINE:
      'Qui est intéressé par votre profil ?',
    NETWORK_MY_NETWORK_ROMP_BASIC_WITH_VISITORS_BANNER_VIEW_ALL_VISITS_CTA:
      'Voir toutes les visites',
    NETWORK_MY_NETWORK_ROMP_BASIC_WITH_VISITORS_VISITOR_FENCED_NAME:
      'Recruteurs',
    NETWORK_MY_NETWORK_ROMP_EMPTY_STATE_BODY:
      'Développez votre réseau et boostez votre visibilité pour obtenir davantage de visites sur votre profil.',
    NETWORK_MY_NETWORK_ROMP_EMPTY_STATE_CTA:
      'Découvrir des professionnels des RH',
    NETWORK_MY_NETWORK_ROMP_EMPTY_STATE_HEADLINE:
      "Vous n'avez pas encore reçu de visites de recruteurs sur votre profil ?",
    NETWORK_MY_NETWORK_ROMP_PREMIUM_REASSURANCE_BODY:
      'En tant que membre Premium, vous visualisez les professionnels des RH qui ont consulté votre profil.',
    NETWORK_MY_NETWORK_ROMP_PREMIUM_REASSURANCE_CTA:
      'Voir tous les avantages Premium',
    NETWORK_MY_NETWORK_ROMP_PREMIUM_REASSURANCE_HEADLINE:
      "Découvrez les professionnels des RH qui s'intéressent à vous.",
    NETWORK_MY_NETWORK_ROMP_PROJOBS_REASSURANCE_BODY:
      'En tant que membre  ProJobs , vous visualisez les professionnels des RH qui ont consulté votre profil.',
    NETWORK_MY_NETWORK_ROMP_PROJOBS_REASSURANCE_CTA:
      'Découvrir tous les avantages ProJobs',
    NETWORK_MY_NETWORK_ROMP_PROJOBS_REASSURANCE_HEADLINE:
      "Découvrez les professionnels des RH qui s'intéressent à vous.",
    NETWORK_MY_NETWORK_ROMP_VISITORS_ACCEPT_CONTACT_REQUEST: 'Accepter',
    NETWORK_MY_NETWORK_ROMP_VISITORS_ADD_SEND_CONTACT_REQUEST:
      'Ajouter à mes contacts',
    NETWORK_MY_NETWORK_ROMP_VISITORS_DECLINE_CONTACT_REQUEST: 'Refuser',
    NETWORK_MY_NETWORK_ROMP_VISITORS_EXTERNAL_RECRUITER: 'Visite externe',
    NETWORK_MY_NETWORK_ROMP_VISITORS_HEADLINE:
      "Professionnels des qui s'intéressent à vous",
    NETWORK_MY_NETWORK_ROMP_VISITORS_SHOW_MORE_BUTTON: 'Voir plus',
    NETWORK_MY_NETWORK_ROMP_VISITORS_TIME_FRAME:
      'Au cours des 90 derniers jours',
    NETWORK_MY_NETWORK_ROMP_VISITORS_WRITE_MESSAGE: 'Envoyer un message',
    NETWORK_MY_NETWORK_VISIBILITY_BANNER_CTA: 'Optimiser mon profil',
    NETWORK_MY_NETWORK_VISIBILITY_BANNER_DESCRIPTION:
      "Un profil bien renseigné augmente vos chances d'être repéré(e).",
    NETWORK_MY_NETWORK_VISIBILITY_BANNER_TITLE: 'Qualité du profil',
    NETWORK_MYMK_ABOUT_ME_TITLE: 'À propos de moi',
    NETWORK_MYMK_SHOW_MORE_BUTTON: 'Voir plus',
    NETWORK_MYMK_TOTAL_SHARED_CONTACTS_WEB: 'Contacts communs',
    NETWORK_MYNETWORK_BIRTHDAY_EMPTY:
      "Aucun de vos contacts ne fête son anniversaire aujourd'hui.",
    NETWORK_MYNETWORK_BIRTHDAY_HAS_BIRTHDAY: 'fête son anniversaire',
    NETWORK_MYNETWORK_BIRTHDAY_HEADLINE: 'Anniversaires',
    NETWORK_MYNETWORK_BIRTHDAY_MULTIPLE_CONTACTS_HAVE:
      '{count} de vos contacts fêtent',
    NETWORK_MYNETWORK_BIRTHDAY_ONE_CONTACT_HAS: "L'un de vos contacts fête",
    NETWORK_MYNETWORK_BIRTHDAY_TODAY: "anniversaire aujourd'hui :",
    NETWORK_MYNETWORK_BIRTHDAY_TODAY_BECOMES_AGE:
      "fête ses {age} ans aujourd'hui.",
    NETWORK_MYNETWORK_BIRTHDAY_TWO_CONTACTS_HAVE:
      '{name1} und {name2} fêtent leur',
    NETWORK_MYNETWORK_BIRTHDAY_WILL_BECOME_AGE: 'aura {age} ans le {date}.',
    NETWORK_MYNETWORK_BIRTHDAY_WILL_BECOME_AGE_NO_DATE: 'va avoir {age} ans',
    NETWORK_MYNETWORK_BIRTHDAY_WILL_HAVE_BIRTHDAY:
      'fête son anniversaire le {date}',
    NETWORK_MYNETWORK_BIRTHDAY_WILL_HAVE_BIRTHDAY_NO_DATE:
      'fête son anniversaire.',
    NETWORK_MYNETWORK_CONTACT_HEADLINE: 'Contacts',
    NETWORK_MYNETWORK_CONTACT_MULTIPLE: 'Vous avez <b>{count} contacts</b>.',
    NETWORK_MYNETWORK_CONTACT_REQUEST_COMMON_CONTACTS:
      '{amount} contacts communs',
    NETWORK_MYNETWORK_CONTACT_REQUEST_EMPTY_HEADLINE:
      'Aucune demande de contact reçue ',
    NETWORK_MYNETWORK_CONTACT_REQUEST_HEADLINE: 'Demandes de contact',
    NETWORK_MYNETWORK_CONTACT_REQUEST_MULTIPLE_HEADLINE:
      'Vous avez <b>{count} demandes de contact en attente</b>',
    NETWORK_MYNETWORK_CONTACT_REQUEST_SINGLE_HEADLINE:
      'Vous avez <b>une nouvelle demande de contact</b>',
    NETWORK_MYNETWORK_CONTACT_REQUEST_TWO_REQUESTS: 'de {name1} et {name2}.',
    NETWORK_MYNETWORK_CONTACT_REQUEST_VIEW_ALL:
      'Voir toutes les demandes de contact',
    NETWORK_MYNETWORK_CONTACT_REQUESTS_EMPTY_STATE_CTA1:
      'Découvrez de nouveaux contacts',
    NETWORK_MYNETWORK_CONTACT_REQUESTS_EMPTY_STATE_CTA2:
      'Voir toutes les demandes',
    NETWORK_MYNETWORK_CONTACT_REQUESTS_EMPTY_STATE_DESCRIPTION:
      'Nouez de nouveaux contacts et profitez de la puissance de votre réseau.',
    NETWORK_MYNETWORK_CONTACT_REQUESTS_EMPTY_STATE_SUBLINE:
      'Rien à faire pour le moment.',
    NETWORK_MYNETWORK_CONTACT_REQUESTS_EMPTY_STATE_TITLE: 'Demandes de contact',
    NETWORK_MYNETWORK_CONTACT_REQUESTS_ENTRYPOINT_HEADLINE: 'Tout afficher',
    NETWORK_MYNETWORK_CONTACT_SEARCH_PLACEHOLDER:
      'Rechercher dans mes contacts',
    NETWORK_MYNETWORK_CONTACT_SINGLE: 'Vous avez <b>{count} contact</b>.',
    NETWORK_MYNETWORK_DEFAULT_ERROR_MESSAGE:
      'Désolé, une erreur est survenue. Veuillez réessayer.',
    NETWORK_MYNETWORK_EMPTY_STATE_DESCRIPTION:
      'Nouez de nouveaux contacts et profitez de la puissance de votre réseau.',
    NETWORK_MYNETWORK_EMPTY_STATE_HEADLINE: 'Rien à faire pour le moment.',
    NETWORK_MYNETWORK_HEADLINE: 'Votre réseau',
    NETWORK_MYNETWORK_HEADLINE_WEB: 'Réseau',
    NETWORK_MYNETWORK_HIRING_HIGHLIGHTS_BANNER_CONFIRMATION_CTA: 'Votre réseau',
    NETWORK_MYNETWORK_HIRING_HIGHLIGHTS_BANNER_CONFIRMATION_TEXT:
      'Votre réseau',
    NETWORK_MYNETWORK_HIRING_HIGHLIGHTS_BANNER_NO_CTA: 'Votre réseau',
    NETWORK_MYNETWORK_HIRING_HIGHLIGHTS_BANNER_SUBLINE: 'Votre réseau',
    NETWORK_MYNETWORK_HIRING_HIGHLIGHTS_BANNER_TITLE: 'Votre réseau',
    NETWORK_MYNETWORK_HIRING_HIGHLIGHTS_BANNER_YES_CTA: 'Votre réseau',
    NETWORK_MYNETWORK_MEMBER_SEARCH_HEADLINE: 'Trouver des membres',
    NETWORK_MYNETWORK_MEMBER_SEARCH_PLACEHOLDER:
      "Entrer le nom ou l'entreprise",
    NETWORK_MYNETWORK_MYMK_HEADLINE: 'Membres',
    NETWORK_MYNETWORK_NUM_CONTACTS:
      '{count, number} {count, plural,\n  one {contact.}\n  other {contacts.}\n}',
    NETWORK_MYNETWORK_PROFILE_VISITORS_CTA_BASIC: 'Devenir membre Premium',
    NETWORK_MYNETWORK_PROFILE_VISITORS_CTA_PREMIUM:
      'Voir les visites sur le profil',
    NETWORK_MYNETWORK_PROFILE_VISITORS_DESCRIPTION_BASIC:
      'Avec la formule <b>Premium</b>, découvrez qui a consulté votre profil et pourquoi. ',
    NETWORK_MYNETWORK_PROFILE_VISITORS_DESCRIPTION_PREMIUM:
      'Découvrez qui a consulté votre profil et développez votre réseau.',
    NETWORK_MYNETWORK_PROFILE_VISITORS_ENTRYPOINT_CTA: 'Tout afficher',
    NETWORK_MYNETWORK_PROFILE_VISITORS_ENTRYPOINT_HEADLINE:
      "Envie de savoir qui s'intéresse à vous ?",
    NETWORK_MYNETWORK_PROFILE_VISITORS_HEADLINE: 'Visites sur le profil',
    NETWORK_MYNETWORK_PROFILE_VISITORS_NUMBER_OF_VISITS: 'visites',
    NETWORK_MYNETWORK_RECOMMENDATIONS_COMPANIES:
      'Vous êtes collègues de travail.',
    NETWORK_MYNETWORK_RECOMMENDATIONS_COMPANIES_CONTACTS_MANY:
      'Vous travaillez ans la même entreprise et avez {count}  contacts communs.',
    NETWORK_MYNETWORK_RECOMMENDATIONS_COMPANIES_CONTACTS_ONE:
      'Vous travaillez ans la même entreprise et avez un contact commun.',
    NETWORK_MYNETWORK_RECOMMENDATIONS_COMPANIES_CONTACTS_PRIVATE:
      'Vous êtes collègues de travail et avez des contacts communs.',
    NETWORK_MYNETWORK_RECOMMENDATIONS_COMPANIES_EVENTS:
      'Vous êtes collègues et avez participé aux mêmes événements.',
    NETWORK_MYNETWORK_RECOMMENDATIONS_COMPANIES_GROUPS:
      'Vous êtes collègues et membres des mêmes groupes.',
    NETWORK_MYNETWORK_RECOMMENDATIONS_COMPANIES_PAST:
      'Vous avez été collègues.',
    NETWORK_MYNETWORK_RECOMMENDATIONS_COMPANIES_PAST_CONTACTS_MANY:
      'Vous avez travaillé dans la même entreprise et avez {count} contacts communs.',
    NETWORK_MYNETWORK_RECOMMENDATIONS_COMPANIES_PAST_CONTACTS_ONE:
      'Vous avez travaillé dans la même entreprise et avez un contact commun.',
    NETWORK_MYNETWORK_RECOMMENDATIONS_COMPANIES_PAST_CONTACTS_PRIVATE:
      'Vous avez travaillé dans la même entreprise et avez des contacts communs.',
    NETWORK_MYNETWORK_RECOMMENDATIONS_COMPANIES_PAST_EVENTS:
      'Vous êtes anciens collègues et avez participé aux mêmes événements.',
    NETWORK_MYNETWORK_RECOMMENDATIONS_COMPANIES_PAST_GROUPS:
      'Vous êtes anciens collègues et membre des mêmes groupes.',
    NETWORK_MYNETWORK_RECOMMENDATIONS_CONTACTS_GROUPS_MANY:
      'Vous avez {count} contacts communs et êtes membres des mêmes groupes.',
    NETWORK_MYNETWORK_RECOMMENDATIONS_CONTACTS_GROUPS_ONE:
      'Vous avez un contact commun et êtes membres des mêmes groupes.',
    NETWORK_MYNETWORK_RECOMMENDATIONS_CONTACTS_GROUPS_PRIVATE:
      'Vous avez des contacts communs et êtes membres des mêmes groupes.',
    NETWORK_MYNETWORK_RECOMMENDATIONS_CONTACTS_MANY:
      'Vous avez {count} contacts communs.',
    NETWORK_MYNETWORK_RECOMMENDATIONS_CONTACTS_ONE:
      'Vous avez un contact commun.',
    NETWORK_MYNETWORK_RECOMMENDATIONS_CONTACTS_PRIVATE:
      'Vous avez des contacts communs.',
    NETWORK_MYNETWORK_RECOMMENDATIONS_CTA: 'Ajouter',
    NETWORK_MYNETWORK_RECOMMENDATIONS_EMAIL_CONTACT:
      "L'un de vos contacts e-mail",
    NETWORK_MYNETWORK_RECOMMENDATIONS_EVENTS:
      'Vous avez participé aux mêmes événements.',
    NETWORK_MYNETWORK_RECOMMENDATIONS_EVENTS_CONTACTS_MANY:
      'Vous avez participé aux mêmes événements et avez des contacts communs .',
    NETWORK_MYNETWORK_RECOMMENDATIONS_EVENTS_CONTACTS_ONE:
      'Vous avez participé aux mêmes événements et avez un contact commun.',
    NETWORK_MYNETWORK_RECOMMENDATIONS_EVENTS_CONTACTS_PRIVATE:
      'Vous avez des contacts communes et avez participé aux mêmes événements.',
    NETWORK_MYNETWORK_RECOMMENDATIONS_EVENTS_GROUPS:
      'Vous êtes membres des mêmes groupes et avez participé aux mêmes événements,',
    NETWORK_MYNETWORK_RECOMMENDATIONS_GROUPS:
      'Vous êtes membres des mêmes groupes.',
    NETWORK_MYNETWORK_RECOMMENDATIONS_HEADLINE: 'Développez votre réseau :',
    NETWORK_MYNETWORK_RECOMMENDATIONS_SEND_MESSAGE: 'Envoyer un message',
    NETWORK_MYNETWORK_RECOMMENDATIONS_SUBLINE: 'Développez votre réseau :',
    NETWORK_MYNETWORK_RECRUITER_INTERACTIONS_CTA_BASIC: 'Opter pour ProJobs',
    NETWORK_MYNETWORK_RECRUITER_INTERACTIONS_CTA_PROJOBS:
      'Afficher les détails',
    NETWORK_MYNETWORK_RECRUITER_INTERACTIONS_DESCRIPTION_BASIC:
      ' Découvrez qui a repéré et sauvegardé votre profil, débloquez tous les avantages Premium, et plus encore avec <b>ProJobs</b>.',
    NETWORK_MYNETWORK_RECRUITER_INTERACTIONS_DESCRIPTION_PROJOBS:
      'Identifiez les professionnels RH qui vous ont repéré(e) et qui ont enregistré votre profil.',
    NETWORK_MYNETWORK_RECRUITER_INTERACTIONS_HEADLINE:
      'Interactions avec les recruteurs',
    NETWORK_MYNETWORK_RECRUITER_INTERACTIONS_NUMBER_OF_BOOKMARKS: 'enregistré',
    NETWORK_MYNETWORK_RECRUITER_INTERACTIONS_NUMBER_OF_SEARCHES:
      'affichages dans les résultats',
    NETWORK_MYNETWORK_RECRUITER_INTERACTIONS_TOTAL: 'Interactions',
    NETWORK_MYNETWORK_RECRUITERS_CTA: 'Votre réseau',
    NETWORK_MYNETWORK_RECRUITERS_DESCRIPTION: 'Votre réseau',
    NETWORK_MYNETWORK_RECRUITERS_HEADLINE: 'Votre réseau',
    NETWORK_MYNETWORK_RECRUITERS_HIRING_DISCIPLINE: 'Votre réseau',
    NETWORK_MYNETWORK_RECRUITERS_HIRING_INDUSTRY: 'Votre réseau',
    NETWORK_MYNETWORK_RECRUITERS_HIRING_JOB_ROLE: 'Votre réseau',
    NETWORK_MYNETWORK_RECRUITERS_MARKER_HIRING: 'Votre réseau',
    NETWORK_MYNETWORK_RECRUITERS_RECOMMENDATIONS_SEE_MORE_CTA: 'Voir plus',
    NETWORK_MYNETWORK_RECRUITERS_RECOMMENDATIONS_SEE_MORE_TEXT:
      "Découvrez d'autres recruteurs.",
    NETWORK_MYNETWORK_TIPBOX_CTA: 'Suivant',
    NETWORK_MYNETWORK_TIPBOX_CTA_FINAL: 'OK',
    NETWORK_MYNETWORK_TIPBOX_MARKER: 'Nouveau',
    NETWORK_MYNETWORK_TIPBOX_PROFILE_VISITORS_DESCRIPTION:
      'Découvrez qui a consulté votre profil et pourquoi.',
    NETWORK_MYNETWORK_TIPBOX_PROFILE_VISITORS_TITLE: 'Visites sur votre profil',
    NETWORK_MYNETWORK_TIPBOX_PROFILE_VISITS_DESCRIPTION:
      'Découvrez les statistiques relatives aux visites sur votre profil',
    NETWORK_MYNETWORK_TIPBOX_PROFILE_VISITS_TITLE: 'Toutes les statistiques',
    NETWORK_MYNETWORK_TIPBOX_RECRUITER_INTERACTIONS_DESCRIPTION:
      'Découvrez quels professionnels des RH ont consulté votre profil.',
    NETWORK_MYNETWORK_TIPBOX_RECRUITER_INTERACTIONS_TITLE:
      'Interactions avec les recruteurs',
    NETWORK_MYNETWORK_TIPBOX_SEARCH_MEMBERS_DESCRIPTION:
      'Entrez un nom ou une entreprise pour effectuer une recherche sur XING.',
    NETWORK_MYNETWORK_TIPBOX_SEARCH_MEMBERS_TITLE: 'Recherche de membres',
    NETWORK_RECOMMENDATION_CATEGORY_ALL: 'Tous',
    NETWORK_RECOMMENDATION_CATEGORY_COWORKER_CURRENT: 'Recommandations',
    NETWORK_RECOMMENDATION_CATEGORY_COWORKER_PREVIOUS: 'Recommandations',
    NETWORK_RECOMMENDATION_CATEGORY_NEW_CONNECTIONS:
      'Nouveaux contacts de vos contacts',
    NETWORK_RECOMMENDATION_CATEGORY_RECOMMENDATIONS: 'Recommandations',
    NETWORK_RECOMMENDATION_CATEGORY_SHARE_CONTACTS: 'Recommandations',
    NETWORK_RECOMMENDATION_CATEGORY_SIMILAR_CAREER_PATH: 'Recommandations',
    NETWORK_RECOMMENDATIONS_ACCEPTED_START_CONVERSATION:
      'Les associations ou organisations dont vous êtres membre',
    NETWORK_RECOMMENDATIONS_ACCEPTED_SUCCESS:
      'Les associations ou organisations dont vous êtres membre',
    NETWORK_RECOMMENDATIONS_EMPTY_STATE_TIP_1:
      'Votre parcours (expérience professionnelle et formation)',
    NETWORK_RECOMMENDATIONS_EMPTY_STATE_TIP_2:
      'Les associations ou organisations dont vous êtres membre',
    NETWORK_RECOMMENDATIONS_EMPTY_STATE_TIPS_COPY:
      "C'est tout ! Ces informations nous permettront de vous proposer des suggestions de contacts.",
    NETWORK_RECOMMENDATIONS_EMPTY_STATE_TIPS_CTA: 'Compléter le profil',
    NETWORK_RECOMMENDATIONS_EMPTY_STATE_TIPS_HEADLINE:
      'Vous souhaitez recevoir des suggestions de contacts ? Rendez-vous sur votre profil XING et complétez les rubriques suivantes :',
    NETWORK_RECOMMENDATIONS_SEND_MESSAGE:
      'Les associations ou organisations dont vous êtres membre',
    NETWORK_RECOMMENDATIONS_SENT_HEADLINE:
      'Les associations ou organisations dont vous êtres membre',
    NETWORK_RECOMMENDATIONS_SENT_SENT_MESSAGE_BASIC:
      'Les associations ou organisations dont vous êtres membre',
    NETWORK_RECOMMENDATIONS_SENT_SENT_MESSAGE_PREMIUM:
      'Les associations ou organisations dont vous êtres membre',
    NETWORK_REQUEST_ERROR_DIALOG_CONTACT_LIMIT_REACHED_CTA:
      'Vos demandes envoyées',
    NETWORK_REQUEST_ERROR_DIALOG_CONTACT_LIMIT_REACHED_HEADLINE:
      'Vous êtes membres des mêmes groupes.',
    NETWORK_REQUEST_ERROR_DIALOG_CONTACT_LIMIT_REACHED_TEXT:
      " Avant d'envoyer d'autres demandes de contact, vérifiez d'abord les anciennes demandes et supprimez-les si nécessaire.",
    NETWORK_REQUESTS_BUTTON_ACCEPT: 'Accepter',
    NETWORK_REQUESTS_BUTTON_REPORT_SPAM: 'Signaler en tant que spam',
    NETWORK_REQUESTS_BUTTON_SEND_MESSAGE: 'Envoyer un message',
    NETWORK_REQUESTS_DIALOG_CANCEL: 'Annuler',
    NETWORK_REQUESTS_DIALOG_DECLINE_HEADLINE:
      'Supprimer cette demande de contact ?',
    NETWORK_REQUESTS_DIALOG_DECLINE_TEXT:
      "Ce(tte) membre n'en sera pas informé(e).",
    NETWORK_REQUESTS_DIALOG_DENY: 'Supprimer la demande',
    NETWORK_REQUESTS_DIALOG_SEND: 'Envoyer',
    NETWORK_REQUESTS_EMPTY_STATE_CTA: 'Découvrez de nouveaux contacts',
    NETWORK_REQUESTS_HEADLINE: 'Demandes de contact',
    NETWORK_REQUESTS_MODAL_OPEN_ARIA_LABEL: 'open modal received requests',
    NETWORK_REQUESTS_RECEIVED_SPAM_HEADER: 'Signaler en tant que spam ou abus',
    NETWORK_REQUESTS_RECEIVED_SPAM_TEXT:
      'Veuillez expliquer brièvement pourquoi vous souhaitez signaler ce contenu en tant que spam. Merci !',
    NETWORK_REQUESTS_TABNAV_RECEIVED: 'Demandes reçues',
    NETWORK_SEARCH_AND_SWIPE_ABOUT_BUTTON_LABEL: 'OK !',
    NETWORK_SEARCH_AND_SWIPE_BOTTOM_SHEET_ABOUT_THIS_FEATURE:
      'About this feature',
    NETWORK_SEARCH_AND_SWIPE_BOTTOM_SHEET_RESTART_TUTORIAL: 'Show tips again',
    NETWORK_SEARCH_AND_SWIPE_CONTACT_REQUEST_LIMIT_DESCRIPTION_WEB:
      "You've reached your limit of 100 sent contact requests. To send more, please review and manage your pending requests.\n{br}<a>View all contacts> Sent requests</a>",
    NETWORK_SEARCH_AND_SWIPE_CONTACT_REQUEST_LIMIT_TITLE:
      'Review your sent contact requests',
    NETWORK_SEARCH_AND_SWIPE_CONTACT_REQUEST_LIMIT_WARNING_BUTTON: 'Got it!',
    NETWORK_SEARCH_AND_SWIPE_CONTACT_REQUEST_LIMIT_WARNING_MESSAGE:
      "You're nearing your limit for sending contact requests. Please keep this in mind as you continue.",
    NETWORK_SEARCH_AND_SWIPE_CONTACT_REQUEST_LIMIT_WARNING_TITLE: 'Be careful!',
    NETWORK_SEARCH_AND_SWIPE_DISCARD_RECOMMENDATION_BUTTON_A11Y:
      'Discard recommendation',
    NETWORK_SEARCH_AND_SWIPE_MYMK_EMPTY_CARD_DESCRIPTION:
      'Try adding more information to your profile. That way, we can provide you with good contact recommendations.',
    NETWORK_SEARCH_AND_SWIPE_MYMK_EMPTY_CARD_TITLE:
      'Aucune recommandation pour le moment',
    NETWORK_SEARCH_AND_SWIPE_MYMK_NO_MORE_RECOMMENDATIONS_DESCRIPTION:
      'To get more and even better recommendations, try adding more information to your profile.',
    NETWORK_SEARCH_AND_SWIPE_MYMK_NO_MORE_RECOMMENDATIONS_TITLE:
      "C'est tout pour le moment.",
    NETWORK_SEARCH_AND_SWIPE_PRIVACY_CONTACT_REQUEST_FAILURE_MESSAGE:
      "Votre demande de contact n'a pas pu être envoyée.",
    NETWORK_SEARCH_AND_SWIPE_PRIVACY_CONTACT_REQUEST_SUCESS_MESSAGE:
      'Votre demande de contact a été envoyée.',
    NETWORK_SEARCH_AND_SWIPE_PRIVACY_POLICY_DESCRIPTION_WEB:
      'When swiping recommended profiles, members are notified when you see some or all of their profile. Visit the section on Clickpath in our <a>Privacy Policy</a> for further details.',
    NETWORK_SEARCH_AND_SWIPE_PRIVACY_POLICY_LINK:
      'https://privacy.xing.com/en/privacy-policy/information-we-automatically-receive-through-your-use-of-xing/provision-of-our-service/examples',
    NETWORK_SEARCH_AND_SWIPE_PRIVACY_POLICY_TITLE: 'About this feature',
    NETWORK_SEARCH_AND_SWIPE_SEND_CONTACT_REQUEST_BUTTON_A11Y:
      'Send contact request',
    NETWORK_SEARCH_AND_SWIPE_TUTORIAL_CONTACT_REQUESTS_HINT_DESCRIPTION_WEB:
      'To review your sent and received <a>contact requests</a>, and to find out what else is happening in your network.',
    NETWORK_SEARCH_AND_SWIPE_TUTORIAL_CONTACT_REQUESTS_HINT_TITLE:
      'Scroll down',
    NETWORK_SEARCH_AND_SWIPE_TUTORIAL_INTO_DESCRIPTION:
      'We’ve revamped contact recommendations to make networking even easier for you.',
    NETWORK_SEARCH_AND_SWIPE_TUTORIAL_INTO_TITLE_WEB: 'Hi {username},',
    NETWORK_SEARCH_AND_SWIPE_TUTORIAL_LEGAL_NOTE_DESCRIPTION_WEB:
      'Members are notified when you see some or all of their profile. Visit the section on Clickpath in our <a>Privacy Policy</a> for further details. ',
    NETWORK_SEARCH_AND_SWIPE_TUTORIAL_LEGAL_NOTE_TITLE: 'One last thing',
    NETWORK_SEARCH_AND_SWIPE_TUTORIAL_SWIPE_LEFT_DESCRIPTION_WEB:
      'This will <b>not</b> send a <b>contact request</b>.',
    NETWORK_SEARCH_AND_SWIPE_TUTORIAL_SWIPE_LEFT_TITLE: 'Swipe left',
    NETWORK_SEARCH_AND_SWIPE_TUTORIAL_SWIPE_RIGHT_DESCRIPTION_WEB:
      'This will send a <b>contact request</b>.',
    NETWORK_SEARCH_AND_SWIPE_TUTORIAL_SWIPE_RIGHT_TITLE: 'Swipe right',
    PROFILE_TEASER_CARD_DESCRIPTION:
      "Cela ne vous coûtera rien et vous ouvrira de nouvelles opportunités pour votre recherche d'emploi.",
    PROFILE_TEASER_CARD_TITLE: 'Créez un profil XING',
    QR_CODE_BANNER_SUBTITLE:
      'Parce que votre nouveau job est à portée de XING.',
    QR_CODE_BANNER_TITLE: "Téléchargez l'application XING",
    REASSURANCE_ARIA_LABEL: 'Badge {variant}',
    RECRUITERS_SECTION_FIRST_SUBTITLE:
      "Créez un profil XING et découvrez automatiquement des offres d'emploi pertinentes.",
    RECRUITERS_SECTION_FIRST_TITLE: 'Ou soyez trouvé(e).',
    RECRUITERS_SECTION_FLAG_COMPANIES: 'Postes à pourvoir',
    RECRUITERS_SECTION_FLAG_RECRUITERS: 'Recrute',
    RECRUITERS_SECTION_REGISTER_BUTTON: 'Créez votre profil et lancez-vous',
    RECRUITERS_SECTION_REGISTER_WITH_GOOGLE_BUTTON: 'Continuer avec Google',
    RECRUITERS_SECTION_SECOND_SUBTITLE:
      "Nouez le contact avec plus de 20 000 recruteurs d'employeurs prestigieux. ",
    RECRUITERS_SECTION_SECOND_TITLE: 'Nouez les bons contacts',
    REGISTER_SECTION_DATE_MARK: "Aujourd'hui",
    REGISTER_SECTION_FIRST_TAG: 'Vos prétentions salariales',
    REGISTER_SECTION_HEADLINE: '4 nouvelles demandes',
    REGISTER_SECTION_SECOND_TAG: "Votre secteur d'activité",
    REGISTER_SECTION_THIRD_TAG: 'Niveau de carrière souhaité',
    SEARCH_AND_SWIPE_SEARCH_WITH_AI:
      "Nouveau : trouvez un emploi avec l'aide de l'IA",
    SEO_SECTION_TITLE: "De nouvelles idées pour votre recherche d'emploi",
    TITLE_CARD_1: 'Offres avec possibilité de télétravail',
    TITLE_CARD_2: "Offres d'emploi aux horaires flexibles",
    TITLE_CARD_3: "Offres d'emploi dans différents domaines",
    TITLE_CARD_4: "Offres d'emploi avec un salaire élevé",
    TITLE_CARD_5: "Offres d'emploi à temps partiel",
    TITLE_CARD_6: "Jobs d'appoint",
    WELCOME_APP_MINIREG_ERROR_EMAIL: "SVP vérifiez l'adresse e-mail entrée.",
    WELCOME_APP_MINIREG_ERROR_FIRST_NAME: 'Veuillez entrer votre prénom ici.',
    WELCOME_APP_MINIREG_ERROR_LAST_NAME:
      'Veuillez entrer votre nom de famille ici.',
    WELCOME_APP_MINIREG_ERROR_PASSWORD_EMAIL:
      'Pour votre sécurité, veuillez choisir un mot de passe différent de celui que vous utilisez pour votre adresse e-mail.',
    WELCOME_APP_MINIREG_ERROR_PASSWORD_LAST_NAME:
      'Pour votre sécurité, veuillez choisir un mot de passe autre que votre prénom.',
    WELCOME_APP_MINIREG_ERROR_PASSWORD_TOO_LONG:
      'Veuillez choisir un mot de passe comportant 1024 caractères maximum.',
    WELCOME_APP_MINIREG_ERROR_PHONE:
      'SVP vérifiez à nouveau le numéro de téléphone.',
    WELCOME_APP_MINIREG_ERROR_TANDC:
      "Veuillez confirmer que vous acceptez les Conditions générales d'utilisation et la Déclaration de confidentialité.",
    WELCOME_COMPLETION_HEADLINE: 'Bienvenue sur XING !',
    WELCOME_COMPLETION_PAGE_META_TITLE: 'Bienvenue sur XING ! | XING',
    WELCOME_COMPLETION_SUBLINE:
      'Il manque quelques informations pour compléter votre inscription :',
    WELCOME_COMPLETION_SUBLINE_B:
      'Il manque quelques informations pour compléter votre inscription :',
    WELCOME_COMPLETION_SUBLINE_C:
      'Il manque quelques informations pour compléter votre inscription :',
    WELCOME_COMPLETION_SUBLINE_D:
      'Il manque quelques informations pour compléter votre inscription :',
    WELCOME_COMPLETION_SUBLINE_E:
      'Il manque quelques informations pour compléter votre inscription :',
    WELCOME_CONFIRMATION_DEFAULT_BOUNCED_BODY:
      "Veuillez vérifier à nouveau votre adresse électronique. Si vous êtes sûr qu'elle est correcte, {link}.",
    WELCOME_CONFIRMATION_DEFAULT_BOUNCED_CTA: "Rectifier l'adresse e-mail",
    WELCOME_CONFIRMATION_DEFAULT_BOUNCED_HEADER:
      "Malheureusement, l'e-mail qui vous a été envoyé est revenu.",
    WELCOME_CONFIRMATION_DEFAULT_BOUNCED_SUPPORT_LINK_TEXT: 'contactez-nous',
    WELCOME_CONFIRMATION_DEFAULT_BUTTON: "Vous n'avez pas reçu l'e-mail ?",
    WELCOME_CONFIRMATION_DEFAULT_COPY_1:
      'Activez dès maintenant votre compte :',
    WELCOME_CONFIRMATION_DEFAULT_COPY_1_C:
      'Nous vous avons envoyé un lien à {email}.*',
    WELCOME_CONFIRMATION_DEFAULT_COPY_1_D:
      'Confirmez dès maintenant votre compte :',
    WELCOME_CONFIRMATION_DEFAULT_COPY_2:
      'Nous avons envoyé le lien par e-mail à {email}.*',
    WELCOME_CONFIRMATION_DEFAULT_COPY_2_C:
      'Cliquez dessus pour confirmer votre adresse e-mail.',
    WELCOME_CONFIRMATION_DEFAULT_COPY_2_D:
      'Cliquez sur ce lien pour finaliser votre inscription.',
    WELCOME_CONFIRMATION_DEFAULT_HEADLINE: 'Vous y êtes presque !',
    WELCOME_CONFIRMATION_DEFAULT_HEADLINE_C: 'Vous avez un message :',
    WELCOME_CONFIRMATION_DEFAULT_HEADLINE_D: 'Pour votre sécurité...',
    WELCOME_CONFIRMATION_DEFAULT_SUFFIX:
      '* Rien reçu ? Consultez également le dossier "Spam" ou "Courrier indésirable". SI vous utilisez Gmail, veuillez également vérifier les dossiers "Publicité" ou "Réseaux sociaux".',
    WELCOME_CONFIRMATION_EDIT_EMAIL_BUTTON:
      "Envoyer un nouveau lien d'activation",
    WELCOME_CONFIRMATION_EDIT_EMAIL_COPY:
      "Si ce n'est pas le cas,  vous pouvez le rectifier ici :",
    WELCOME_CONFIRMATION_EDIT_EMAIL_HEADLINE:
      'Votre adresse e-mail est-elle correcte ?',
    WELCOME_CONFIRMATION_EDIT_EMAIL_LABEL: 'E-Mail',
    WELCOME_CONFIRMATION_EDIT_EMAIL_REQUEST_ERROR:
      'Désolé, une erreur est survenue ! Veuillez réessayer.',
    WELCOME_CONFIRMATION_EMAIL_RESENT_BUTTON:
      "Vous n'avez toujours pas reçu l'e-mail ?",
    WELCOME_CONFIRMATION_EMAIL_RESENT_COPY_1:
      "Nous avons envoyé un nouveau lien d'activation par e-mail à {email}",
    WELCOME_CONFIRMATION_EMAIL_RESENT_COPY_2:
      "Finalisez votre inscription en cliquant sur le lien d'activation dans l'e-mail que nous vous avons envoyé.",
    WELCOME_CONFIRMATION_EMAIL_RESENT_HEADLINE: 'E-mail envoyé !',
    WELCOME_CONFIRMATION_PAGE_META_TITLE: 'Activer le compte XING | XING',
    WELCOME_GDPR_IMG_ALT:
      'XING respecte la protection des données conformément au RGPD.',
    WELCOME_INVITATION_HEADLINE:
      '{firstname} {lastname} vous invite à rejoindre XING.',
    WELCOME_INVITATION_SUBLINE:
      'Inscrivez-vous pour confirmer la demande de contact de {firstname}.',
    WELCOME_LANGUAGE_PAGE_META_TITLE: 'Sélectionner la langue | XING',
    WELCOME_LANGUAGE_SELECT_ENGLISH_LABEL: 'English',
    WELCOME_LANGUAGE_SELECT_FRENCH_LABEL: 'Français',
    WELCOME_LANGUAGE_SELECT_GERMAN_LABEL: 'Deutsch',
    WELCOME_LANGUAGE_SELECT_HEADLINE:
      'Dans quelle langue souhaitez-vous utiliser XING ?',
    WELCOME_LANGUAGE_SELECT_ITALIAN_LABEL: 'Italiano',
    WELCOME_LANGUAGE_SELECT_SPANISH_LABEL: 'Español',
    WELCOME_LOGIN_FORM_EMAIL_REQUIRED_ERROR:
      'Veuillez entrer votre adresse e-mail ici.',
    WELCOME_LOGIN_FORM_FIRSTNAME_REQUIRED_ERROR:
      'Veuillez entrer votre prénom ici.',
    WELCOME_LOGIN_FORM_LASTNAME_REQUIRED_ERROR:
      'Veuillez entrer votre nom de famille ici.',
    WELCOME_LOGIN_FORM_PASSWORD_REQUIRED_ERROR:
      'Veuillez entrer votre mot de passe ici.',
    WELCOME_LOGIN_FORM_PASSWORD_REQURED_ERROR:
      'Veuillez entrer votre mot de passe ici.',
    WELCOME_LOGIN_FORM_REMEMEMBER_ME_LABEL: 'Rester connecté(e)',
    WELCOME_LOGIN_FORM_SUBMIT_REQUEST_ERROR:
      'Désolé, une erreur est survenue. Veuillez réessayer.',
    WELCOME_LOGIN_FORM_USERNAME_REQUIRED_ERROR:
      'Veuillez entrer votre adresse e-mail ici.',
    WELCOME_LOGIN_HEADLINE: 'Heureux de vous revoir !',
    WELCOME_LOGIN_PASSWORD_LABEL: 'Mot de passe',
    WELCOME_LOGIN_PROBLEMS_LOGGING_IN: "Vous n'arrivez pas à vous connecter ?",
    WELCOME_LOGIN_SUBMIT_LABEL: 'Connexion',
    WELCOME_LOGIN_USERNAME_LABEL: 'E-mail',
    WELCOME_REGISTRATION_CTA_REG_7503_E: 'Créer un nouveau profil',
    WELCOME_REGISTRATION_CTA_REG_7504_A: 'Suivant',
    WELCOME_REGISTRATION_CTA_REG_7504_B: "Je m'inscris",
    WELCOME_REGISTRATION_CTA_REG_7504_C: "Je m'inscris",
    WELCOME_REGISTRATION_CTA_REG_7504_D: 'Créer un profil',
    WELCOME_REGISTRATION_CTA_REG_7504_E: 'Rejoindre XING',
    WELCOME_REGISTRATION_DATAPROTECTION_LABEL: 'Déclaration de confidentialité',
    WELCOME_REGISTRATION_DATAPROTECTION_LINK:
      'https://privacy.xing.com/en/privacy-policy',
    WELCOME_REGISTRATION_EMAIL_LABEL: 'Email',
    WELCOME_REGISTRATION_FIRSTNAME_LABEL: 'Prénom',
    WELCOME_REGISTRATION_HEADLINE: 'Créez votre profil XING gratuit :',
    WELCOME_REGISTRATION_HEADLINE_REG_7088_B:
      'Inscrivez-vous gratuitement en 2 minutes seulement !',
    WELCOME_REGISTRATION_HEADLINE_REG_7088_C:
      'Inscrivez-vous gratuitement en 2 minutes seulement !',
    WELCOME_REGISTRATION_HEADLINE_REG_7088_D:
      'Inscrivez-vous gratuitement en 2 minutes seulement !',
    WELCOME_REGISTRATION_HEADLINE_REG_7088_E:
      'Inscrivez-vous gratuitement en 2 minutes seulement !',
    WELCOME_REGISTRATION_HEADLINE_REG_7396_B:
      'Inscrivez-vous gratuitement en 2 minutes seulement !',
    WELCOME_REGISTRATION_HEADLINE_REG_7396_C:
      'Inscrivez-vous gratuitement en 2 minutes seulement !',
    WELCOME_REGISTRATION_HEADLINE_REG_7396_D:
      'Inscrivez-vous gratuitement en 2 minutes seulement !',
    WELCOME_REGISTRATION_HEADLINE_REG_7550_CMP:
      "Inscrivez-vous maintenant et bénéficiez d'un Abonnement Premium gratuit de 30 jours",
    WELCOME_REGISTRATION_IGNORE_SOFT_EMAIL_ERRORS_LABEL:
      'Oui, {email} est bien mon adresse e-mail valide.',
    WELCOME_REGISTRATION_LASTNAME_LABEL: 'Nom',
    WELCOME_REGISTRATION_PASSWORD_LABEL: 'Mot de passe',
    WELCOME_REGISTRATION_RECAPTCHA_HEADLINE: 'Vous y êtes presque !',
    WELCOME_REGISTRATION_RECAPTCHA_PARAGRAPH:
      'Afin de prévenir le spam, nous souhaitons vérifier que vous êtes bien une personne réelle.',
    WELCOME_REGISTRATION_SOFT_EMAIL_ERROR:
      'Veuillez vérifier à nouveau que votre adresse e-mail est correcte.',
    WELCOME_REGISTRATION_SUBMIT_LABEL: 'Suivant',
    WELCOME_REGISTRATION_TANDC_DESCRIPTION:
      'J’accepte les {tandc} et la {dataprotection} de XING.',
    WELCOME_REGISTRATION_TANDC_LABEL: 'CGU',
    WELCOME_REGISTRATION_TIMER_CAPTCHA_BUTTON:
      'Cliquez ici et maintenez le bouton appuyé pendant 5 secondes',
    WELCOME_REGISTRATION_TIMER_CAPTCHA_ERROR:
      "Cela n'a pas fonctionné. Cliquez avec la souris sur le bouton et maintenez le bouton appuyé pendant 5 secondes.",
    WELCOME_REGISTRATION_TIMER_CAPTCHA_HEADLINE: 'Une dernière vérification',
    WELCOME_REGISTRATION_TIMER_CAPTCHA_PARAGRAPH:
      "Ceci nous permet de vérifier que vous n'êtes pas un robot. Cliquez ici sur le bouton maintenez le bouton appuyé pendant 5 secondes",
    WELCOME_REGISTRATION_VIA_CV_BAD_FILE_ERROR_LABEL:
      "Impossible de charger le fichier {fileName}. Ceci peut être dû au fait qu'il est trop volumineux ou que le format est erroné.",
    WELCOME_REGISTRATION_VIA_CV_BUTTON_LABEL: 'Importer le CV',
    WELCOME_REGISTRATION_VIA_CV_COMMON_ERROR_LABEL:
      'Désolés, une erreur est survenue. Veuillez réessayer.',
    WELCOME_REGISTRATION_VIA_CV_DESCRIPTION_DEFAULT:
      'Transférez maintenant votre CV , nous complèterons automatiquement votre profil XING avec vos données.',
    WELCOME_REGISTRATION_VIA_CV_DESCRIPTION_SUCCESS:
      'Nous avons automatiquement complété votre CV avec les informations que vous nous avez fournies {br}{br} Veuillez vérifier brièvement que tout est exact et, le cas échéant, ajouter les informations manquantes.',
    WELCOME_REGISTRATION_VIA_CV_FILE_INFO_LABEL:
      'Format : document PDF, Word (.docx) ou Pages (max. 100 Mo)',
    WELCOME_REGISTRATION_VIA_CV_HEADLINE_DEFAULT:
      'Gagnez du temps (facultatif)',
    WELCOME_REGISTRATION_VIA_CV_HEADLINE_SUCCESS: 'Votre CV',
    WELCOME_SEARCHPAGE_CTA:
      'Dénichez ici votre prochain job ou retrouvez vos collègues et amis.',
    WELCOME_SEARCHPAGE_HEADLINE: "Trouvez des offres d'emploi et des gens",
    WELCOME_SEARCHPAGE_JOBS_BUTTON: 'Emploi',
    WELCOME_SEARCHPAGE_JOBS_PLACEHOLDER:
      'Entrer un intitulé de poste ou mot-clé',
    WELCOME_SEARCHPAGE_MEMBERS_BUTTON: 'Membres',
    WELCOME_SEARCHPAGE_MEMBERS_PLACEHOLDER:
      'Entrer un nom, une entreprise ou un mot-clef',
    WELCOME_SEARCHPAGE_SEARCH_BUTTON: 'Rechercher',
    WELCOME_SIGNUP_FORM_SUBMIT_REQUEST_ERROR:
      'Désolé, une erreur est survenue. Veuillez réessayer.',
    WELCOME_SIGNUP_FORM_VALIDATE_RELOAD_ERROR:
      'Une erreur est survenue. Veuillez activer les cookies dans les paramètres de votre navigateur puis recharger la page.',
    WELCOME_SIGNUP_FORM_VALIDATE_REQUEST_ERROR:
      'Désolé, une erreur est survenue. Veuillez réessayer.',
    WELCOME_SIGNUP_PAGE_META_TITLE: 'Inscrivez-vous gratuitement | XING',
    WELCOME_SIGNUP_USP_CONTACTS_COPY:
      'Connectez-vous avec plus de 20 millions de membres.',
    WELCOME_SIGNUP_USP_CONTACTS_TITLE: 'Des contacts précieux',
    WELCOME_SIGNUP_USP_FREE_COPY:
      "L'abonnement standard XING est gratuit et le restera toujours.",
    WELCOME_SIGNUP_USP_FREE_TITLE: 'Utiliser XING gratuitement',
    WELCOME_SIGNUP_USP_PRESENCE_COPY:
      "Rejoignez le premier réseau de networking professionnel dans l'espace germanophone.",
    WELCOME_SIGNUP_USP_PRESENCE_TITLE: 'Une présence accrue',
    WELCOME_SIGNUP_USP_SECURITY_COPY:
      'XING respecte la législation allemande sur la protection des données.',
    WELCOME_SIGNUP_USP_SECURITY_TITLE: 'Une sécurité optimale',
    WELCOME_SIGNUP_USPS_TITLE:
      'XING – toutes les clés de la   réussite professionnelle',
    WELCOME_STARTPAGE_APP_STORE_BADGE_ALT: "Télécharger dans l'App Store",
    WELCOME_STARTPAGE_CULTURE_CHECK_BUTTON: "Accéder à l'analyse culturelle",
    WELCOME_STARTPAGE_CULTURE_CHECK_IMG_ALT:
      "Un graphique illustrant l'analyse de la culture d'entreprise.",
    WELCOME_STARTPAGE_CULTURE_CHECK_TEXT:
      "Que préférez-vous : les hiérarchies horizontales ou les consignes claires ? De nombreux facteurs déterminent la culture d'entreprise, identifiez ceux qui comptent le plus à vos yeux. Ainsi, vous saurez ce que vous devez rechercher dans votre prochain emploi. Découvrez dès maintenant  votre analyse culturelle.",
    WELCOME_STARTPAGE_CULTURE_CHECK_TITLE:
      'Travaillez là où vous vous sentez bien.',
    WELCOME_STARTPAGE_CULTURE_COMPASS_BUTTON:
      'Découvrir la boussole culturelle',
    WELCOME_STARTPAGE_CULTURE_COMPASS_IMG_ALT:
      'Un graphique sur la culture d\'entreprise avec une échelle allant de "traditionnelle" à  "moderne".',
    WELCOME_STARTPAGE_CULTURE_COMPASS_TEXT:
      "Vous vous êtes toujours demandé comment est l'ambiance de travail dans telle ou telle entreprise ? Avec la boussole culturelle, découvrez la culture d'entreprise des employeurs que vous convoitez. Avant de postuler, identifiez les entreprises qui vous correspondent le mieux.",
    WELCOME_STARTPAGE_CULTURE_COMPASS_TITLE: 'Suivez la boussole culturelle',
    WELCOME_STARTPAGE_DOWNLOAD_APP_CTA:
      'Envie de découvrir la nouvelle application XING ?',
    WELCOME_STARTPAGE_FORM_TITLE_REG_7371_01:
      'Inscrivez-vous gratuitement en 2 minutes seulement :',
    WELCOME_STARTPAGE_FORM_TITLE_REG_7371_02:
      'Inscrivez-vous gratuitement en 2 minutes seulement :',
    WELCOME_STARTPAGE_FORM_TITLE_REG_7371_03:
      'Devenez membre gratuitement en 2 minutes :',
    WELCOME_STARTPAGE_FORM_TITLE_REG_7371_04:
      'Inscrivez-vous gratuitement en 2 minutes seulement :',
    WELCOME_STARTPAGE_GOOGLE_PLAY_BADGE_ALT: 'Maintenant sur Google Play',
    WELCOME_STARTPAGE_HEADER_BUTTON: "Je m'inscris",
    WELCOME_STARTPAGE_HEADER_IMAGE_ALT:
      'Femme épanouie, allongée sur une chaise',
    WELCOME_STARTPAGE_HEADER_SUBTITLE: 'Créez votre propre XING !',
    WELCOME_STARTPAGE_HEADER_TITLE:
      'Il est temps de vous épanouir professionnellement',
    WELCOME_STARTPAGE_JOBS_DIRECTORY_NAVIGATION_TITLE:
      "Offres d'emploi de A à Z",
    WELCOME_STARTPAGE_JOBS_VERSION_HEADER_BUTTON: 'Inscription gratuite',
    WELCOME_STARTPAGE_JOBS_VERSION_HEADER_SUBTITLE:
      'Ou laissez-nous le trouver pour vous. Fates le test :',
    WELCOME_STARTPAGE_JOBS_VERSION_HEADER_TITLE:
      "Trouvez l'emploi{br}\nqui vous convient :",
    WELCOME_STARTPAGE_JOBS_VERSION_JOB_FILTER_DOGS_FRIENDLY: 'Chiens acceptés',
    WELCOME_STARTPAGE_JOBS_VERSION_JOB_FILTER_FLEXIBILITY: 'Horaires flexibles',
    WELCOME_STARTPAGE_JOBS_VERSION_JOB_FILTER_PART_TIME: 'Temps partiel',
    WELCOME_STARTPAGE_JOBS_VERSION_JOB_FILTER_REMOTE: 'Télétravail',
    WELCOME_STARTPAGE_JOBS_VERSION_JOB_INPUT_PLACEHOLDER:
      'Entrer un intitulé de poste ou mot-clé',
    WELCOME_STARTPAGE_JOBS_VERSION_LOCATION_INPUT_PLACEHOLDER: 'Lieu',
    WELCOME_STARTPAGE_JOBS_VERSION_SEARCH_SUBMIT_BUTTON: 'Trouver un emploi',
    WELCOME_STARTPAGE_JOBS_VERSION_SECTION_ONE_IMG_ALT:
      "Dessin d'une personne et d'un CV",
    WELCOME_STARTPAGE_JOBS_VERSION_SECTION_ONE_TEXT:
      "Qu'il s'agisse d'un déménagement, d'un changement de vie ou simplement d'une envie de découvrir quelque chose de nouveau : XING vous aide à atteindre vos objectifs professionnels, en restant fidèle à vous-même.",
    WELCOME_STARTPAGE_JOBS_VERSION_SECTION_ONE_TITLE:
      'Sur XING, vous êtes bien plus que votre CV',
    WELCOME_STARTPAGE_JOBS_VERSION_SECTION_THREE_IMG_ALT:
      'Dessin représentant une personne avec une image sur laquelle apparaissent plusieurs têtes.',
    WELCOME_STARTPAGE_JOBS_VERSION_SECTION_THREE_TEXT:
      "Sur XING, plus de 20 000 recruteurs sont à portée de clic. Nouez le contact avec  des spécialistes des RH et du marché du travail et dialoguez avec les recruteurs et les collaborateurs de l'employeur de votre choix. Participez et faites votre XING !",
    WELCOME_STARTPAGE_JOBS_VERSION_SECTION_THREE_TITLE:
      "S'adresser aux bonnes personnes",
    WELCOME_STARTPAGE_JOBS_VERSION_SECTION_TWO_IMG_ALT:
      "Dessin d'une personne avec des couvre-chefs spécifiques à différentes professions.",
    WELCOME_STARTPAGE_JOBS_VERSION_SECTION_TWO_TEXT:
      "Vous trouverez ici une sélection des meilleures offres d'emploi et bénéficierez des recommandations pertinentes au bon moment. Identifiez vos objectifs, approfondissez vos connaissances et rencontrez des employeurs dont la culture d'entreprise vous correspond.",
    WELCOME_STARTPAGE_JOBS_VERSION_SECTION_TWO_TITLE:
      "1,4 millions d'offres d'emploi et autant d'opportunités",
    WELCOME_STARTPAGE_JOBSFINDER_CTA_BUTTON: "Je m'inscris",
    WELCOME_STARTPAGE_JOBSFINDER_CTA_TEXT:
      "Quel est l'impact de la localisation et du secteur d'activité sur le salaire ? Découvrez-le avec XING.",
    WELCOME_STARTPAGE_JOBSFINDER_IMG_ALT:
      'Femme essayant de travailler dans une position inconfortable',
    WELCOME_STARTPAGE_JOBSFINDER_SUBTITLE: 'Resetez fidèle à vous-même :',
    WELCOME_STARTPAGE_JOBSFINDER_SUGGESTION_CONSULTING: 'Conseil',
    WELCOME_STARTPAGE_JOBSFINDER_SUGGESTION_IT: "Technologies de l'information",
    WELCOME_STARTPAGE_JOBSFINDER_SUGGESTION_LOGISTICS: 'Logistique',
    WELCOME_STARTPAGE_JOBSFINDER_SUGGESTION_MARKETING: 'Marketing',
    WELCOME_STARTPAGE_JOBSFINDER_SUGGESTION_MORE_JOBS: "Voir plus d'offres",
    WELCOME_STARTPAGE_JOBSFINDER_SUGGESTION_PROJECT_MANAGEMENT:
      'Gestion de projets',
    WELCOME_STARTPAGE_JOBSFINDER_TITLE: "Trouvez l'emploi qui vous convient.",
    WELCOME_STARTPAGE_KEY_FEATURES_EVENTS: "1,7 millions d'événements",
    WELCOME_STARTPAGE_KEY_FEATURES_JOBS: "Plus de 250 000 offres d'emploi",
    WELCOME_STARTPAGE_KEY_FEATURES_MEMBERS: '20 millions de membres',
    WELCOME_STARTPAGE_KEY_FEATURES_NEWS:
      "Chaque jour, de nouvelles actualités de votre secteur d'activité\n",
    WELCOME_STARTPAGE_MAIN_CTA_BUTTON: 'Inscrivez-vous gratuitement',
    WELCOME_STARTPAGE_MAIN_CTA_TEXT:
      "XING - le premier réseau de networking professionnel dans l'espace germanophone.",
    WELCOME_STARTPAGE_MAIN_DESCRIPTION:
      "XING est votre assistant de carrière personnel. Nouez des contacts professionnels, découvrez des offres d'emploi, des événements, des actualités et des groupes passionnants.",
    WELCOME_STARTPAGE_MAIN_DESCRIPTION_REG_7088_B:
      'Trouvez un emploi qui vous ressemble.',
    WELCOME_STARTPAGE_MAIN_DESCRIPTION_REG_7088_C:
      "Créez votre propre réseau de contacts, échangez des idées et dialoguez avec des gens qui partagent vos centres d'intérêt.",
    WELCOME_STARTPAGE_MAIN_DESCRIPTION_REG_7088_D:
      "Retrouvez l'actualité de vos collègues, nouez le contact et dialoguez avec des gens qui partagent vos centres d'intérêt.",
    WELCOME_STARTPAGE_MAIN_DESCRIPTION_REG_7088_E:
      "Créez votre propre réseau de contacts, échangez des idées et dialoguez avec des gens qui partagent vos centres d'intérêt.",
    WELCOME_STARTPAGE_MAIN_SUBTITLE_REG_7494:
      'Für Dein Leben. Für Deinen Job. Für Dein Job-Leben.',
    WELCOME_STARTPAGE_MAIN_TITLE:
      'XING –Des idées pour le monde du travail de demain',
    WELCOME_STARTPAGE_MAIN_TITLE_REG_7088_B: 'Trouvez votre prochain emploi',
    WELCOME_STARTPAGE_MAIN_TITLE_REG_7088_C:
      'Tirez parti de votre réseau pour atteindre vos objectifs.',
    WELCOME_STARTPAGE_MAIN_TITLE_REG_7088_D:
      'Votre parcours professionnel ? Une histoire de réseau.',
    WELCOME_STARTPAGE_MAIN_TITLE_REG_7088_E:
      "Rencontrer les gens qu'il faut pour évoluer professionnellement",
    WELCOME_STARTPAGE_MAIN_TITLE_REG_7371_01:
      'Travailler mieux pour vivre mieux : trouvez le job qui vous ressemble.',
    WELCOME_STARTPAGE_MAIN_TITLE_REG_7371_02:
      "N'attendez plus : trouvez dès maintenant un emploi qui vous ressemble.",
    WELCOME_STARTPAGE_MAIN_TITLE_REG_7371_03:
      'XING – Votre allié professionnel.',
    WELCOME_STARTPAGE_MAIN_TITLE_REG_7371_04:
      'Travailler mieux pour vivre mieux : trouvez le job qui vous ressemble.',
    WELCOME_STARTPAGE_MAIN_TITLE_REG_7494: 'Weil Du’s Dir vorgenommen hast.',
    WELCOME_STARTPAGE_MAIN_TITLE_REG_7747:
      'Votre parcours professionnel ? Une histoire de réseau.',
    WELCOME_STARTPAGE_MEMBER_DIRECTORY_NAVIGATION_TITLE: 'Membres de A à Z',
    WELCOME_STARTPAGE_META_DESCRIPTION:
      "XING est votre assistant de carrière personnel. Nouez des contacts professionnels, découvrez des offres d'emploi, des événements, des actualités et des groupes passionnants.",
    WELCOME_STARTPAGE_META_DESCRIPTION_JOB_SEARCH:
      "✓ Analyse culturelle ✓ Évaluations d'employeurs ✓ e-Learning ✓ Contacts avec des recruteurs - Personnalisez XING pour une vie professionnelle pleine de sens et riche en satisfactions",
    WELCOME_STARTPAGE_META_TITLE:
      'XING –Des idées pour le monde du travail de demain',
    WELCOME_STARTPAGE_META_TITLE_JOB_SEARCH:
      "XING - Trouvez l'emploi qui vous convient vraiment.",
    WELCOME_STARTPAGE_OG_SITENAME: 'XING',
    WELCOME_STARTPAGE_OG_TITLE:
      'XING –Des idées pour le monde du travail de demain',
    WELCOME_STARTPAGE_PROCEED_WITH_APPLE_BUTTON: 'Continuer avec Apple',
    WELCOME_STARTPAGE_PROCEED_WITH_GOOGLE_BUTTON: "Je m'inscris",
    WELCOME_STARTPAGE_XINGGUIDE_BUTTON: 'En savoir plus',
    WELCOME_STARTPAGE_XINGGUIDE_IMG_ALT:
      "Un message du Guide XING avec une recommandation d'offre d'emploi",
    WELCOME_STARTPAGE_XINGGUIDE_TEXT:
      "Vous êtes à la recherche d'un emploi ou vous venez de décrocher un nouveau poste ? Notre guide vous propose une foule de conseils pour tirer pleinement parti de XING : de l'optimisation de votre profil aux recommandations de contacts ou d'articles pertinents - en fonction de vos besoins du moment.",
    WELCOME_STARTPAGE_XINGGUIDE_TITLE: 'Votre allié professionnel',
    WELCOME_TOGGLE_FORM_BUTTON_LOGIN: 'Connexion',
    WELCOME_TOGGLE_FORM_BUTTON_REGISTER: "Je m'inscris",
    XAM_GENERIC_ERROR_MESSAGE: 'Une erreur est survenue, veuillez réessayer.',
    XAM_LEAD_AD_CUSTOM_QUESTION_PLACEHOLDER: 'Entrez votre réponse ici.',
    XAM_LEAD_AD_FORM_THANKS_CTA_DOWNLOAD_NOW: 'Télécharger maintenant',
    XAM_LEAD_AD_FORM_THANKS_CTA_TRY_NOW: 'Essayer maintenant',
    XAM_LEAD_AD_FORM_THANKS_CTA_VISIT_COMPANY_WEBSITE:
      "Accéder au site web de l'entreprise",
    XAM_LEAD_AD_FORM_THANKS_CTA_VISIT_NOW: 'Consulter maintenant',
    XAM_LEAD_AD_FORM_THANKS_CTA_VISIT_XING_PAGE: 'Accéder à la page XING',
    XAM_LEAD_AD_PREVIEW_CONFIRMATION_SUCCESS_MESSAGE: 'Demande envoyée',
    XAS_ARMSTRONG_LEAD_AD_FORM_THANKS_BUTTON_COPY: 'Voir la page XING',
    XDS_EMPTYSTATE_ERROR_BUTTON: 'Réessayer',
    XDS_EMPTYSTATE_ERROR_DESCRIPTION: 'Veuillez réessayer',
    XDS_EMPTYSTATE_ERROR_TITLE: 'Une erreur est survenue.',
  },
};
